import type { AssetProcessingActivityReviewRow } from 'config/api/ropaReviews/ropaReviews.types';

/** Permanent rows omit can_open_dpia; overlay rows include it. Never invent an id from display status. */
export const canShowOwnerDpiaAction = (row: Pick<AssetProcessingActivityReviewRow, 'dpiaId' | 'canOpenDpia'>): boolean => {
  if (!row.dpiaId) {
    return false;
  }

  if (row.canOpenDpia === undefined) {
    return true;
  }

  return row.canOpenDpia === true;
};

export default canShowOwnerDpiaAction;
